import React, { useState } from "react";
import { toast } from "react-toastify";

import { Form, Modal, InputProps, Loader, Dimmer, Label, Input } from "semantic-ui-react";
import ModalApp from "../../components/ModalApp";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";
import OperatorRepository from "../../Repositories/OperatorRepository";
import CustomLoader from "../../components/CustomLoader";

interface State {
    nome: string;
    senha: string;
    apiErrors: IAliancaErrors;
}

interface Props {
    onSuccess: () => void;
}

const initialState: State = {
    nome: "",
    senha: "",
    apiErrors: { errors: [] }
}


const CadastrarOperador: React.FC<Props> = ({ onSuccess }) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>(initialState);
    const [open, setOpen] = useState<boolean>(false);


    const handleSubmitForm = async () => {
        try {
            setLoading(true);

            const { nome, senha } = state;

            const response = await OperatorRepository.Insert({ nome, senha });

            toast(`🎉 ${response.message}`, { position: "top-center", type: "success" });
            setOpen(false);
            onSuccess();

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            setState({ ...state, apiErrors: err.response.data });

            const error = errors.getApiErrors(state.apiErrors);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setLoading(false);
    }

    const handleOpen = () => {
        setState(initialState);
        setOpen(true);
    }

    const handleClose = () => { setOpen(false); }

    const hasError = (key: string) => {
        return errors.hasError(state.apiErrors, key);
    }

    const getMessage = (key: string) => {
        return errors.getMessage(state.apiErrors, key);
    }

    const cadastrarContent = (
        <Modal.Content scrolling>
            {loading &&
                <Dimmer active inverted>
                    <CustomLoader />
                </Dimmer>}
            {!loading &&
                <Form>
                    <Form.Field error={hasError("Nome")} required>
                        <label>Nome</label>
                        <Input
                            placeholder="Nome"
                            value={state.nome}
                            onChange={(e: InputProps) => setState({ ...state, nome: e.target.value })}
                        />
                        {hasError("Nome") && <Label pointing prompt>{getMessage("Nome")}</Label>}
                    </Form.Field>
                    <Form.Field error={hasError("Senha")} required>
                        <label>Senha</label>
                        <Input
                            placeholder="Senha"
                            type="password"
                            value={state.senha}
                            onChange={(e: InputProps) => setState({ ...state, senha: e.target.value })}
                        />
                        {hasError("Senha") && <Label pointing prompt>{getMessage("Senha")}</Label>}
                    </Form.Field>

                </Form>}
        </Modal.Content>
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Cadastrar"
            content={cadastrarContent}
            trigger={{
                icon: "add",
                color: "pink",
                content: "Novo",
                labelPosition: "left",
                floated: "right"
            }}
            onSuccess={{ content: "Salvar", func: handleSubmitForm }}
        />
    );
};

export default CadastrarOperador;
